import axios from 'axios'
import cookie from '~/utils/cookie'
import { getLoginPath } from '~/utils/assist'

export const baseURL = {
  'production': 'https://xueshi-service.yoyohr.com',
  'lan': 'http://xueshicloud-service.youpin-k8s.net',
  // 'development': 'http://192.168.1.17:9903'
  'development': 'http://9903.lan.sakuraio.com'
}[process.env.NODE_ENV]

const eid = cookie.get('eid')

// 30秒中断请求
axios.defaults.timeout = 30000

// 拦截发送请求
axios.interceptors.request.use(
  config => {
    let token = cookie.get('token')
    token && (config.headers.Authorization = 'Bearer ' + token)
    let deviceId = cookie.get('device_id')
    deviceId && (config.headers.DeviceId = deviceId)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 拦截返回结果
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let token
      if (res.headers && res.headers.authorization) {
        token = res.headers.authorization.substr(7)
        cookie.set('token', token)
      }
      if (res.data.code === 10127 || res.data.code === 10126 || res.data.code === 10117) {
        // token失效
        cookie.remove('token')
        cookie.remove('device_id')
        // 返回登录
        location.href = getLoginPath()
      } else if (res.data.code === 910801) {
        // 无权限操作项目
        // location.replace('/project/list/managed')
      }
    }
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * request封装
 */
function fetchData (method, url, data = {}) {
  return new Promise((resolve, reject) => {
    let request
    eid && (data.current_eid = eid)
    if (method === 'get' || method === 'delete') {
      request = axios[method](baseURL + url, { params: data })
    } else {
      request = axios[method](baseURL + url, data)
    }
    request
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export function get (url, params) {
  return fetchData('get', url, params)
}

export function post (url, data) {
  return fetchData('post', url, data)
}

export function put (url, data) {
  return fetchData('put', url, data)
}

export function remove (url, params) {
  return fetchData('delete', url, params)
}

export function upload (url, data) {
  const formData = new FormData()
  Object.keys(data).forEach((child) => {
    formData.append(child, data[child])
  })
  return post(url, formData)
}



// WEBPACK FOOTER //
// ./src/api/config.js